import * as React from "react"
import { ModalComponent } from "./ModalComponent";
import { ModalSize } from "../utils/AppConstants";
import BrowserUtils from "../utils/BrowserUtils";

interface IncompatibleBrowserModalProps {
    isOpen?: boolean
}

const IncompatibleBrowserModal: React.FunctionComponent<IncompatibleBrowserModalProps> = (props: IncompatibleBrowserModalProps) => {
    const isCompatible = BrowserUtils.isCompatibleBrowser()
    const [isOpen, toggleModal] = React.useState(!isCompatible)
    if (!isOpen) return null

    const handleDownloadChrome = () => {
        const chromeWindow = window.open("https://www.google.com/chrome/", "_blank")
        // chromeWindow.onload = () => {
        //     setTimeout(() => {
        //         const buttons = chromeWindow.document.getElementsByTagName("button")
        //         const downloadBtn = buttons.find((btn: any) => btn.innerText === "Download Chrome")
        //         if (downloadBtn) downloadBtn.click()
        //         chromeWindow.close()
        //     })
        // }
    }
    const isIos = BrowserUtils.isIos();
    return (
        <ModalComponent modalSize={ModalSize.LARGE}>
            <div className={"browser-container"}>
                <div className={"img-container"}>
                    <img src={isIos ? `/images/safari.png` : `/images/download-chrome.png`} />
                </div>
                <div className={"txt-body-container"}>
                    <div className={"header brandon-bold"}>You are using an incompatible browser</div>
                    {!isIos &&
                        <div className={"txt"}>You are using an incompatible browser. Please log in using the google chrome browser.
                        <br />
                            <a onClick={handleDownloadChrome}>Click here to get chrome</a>
                        </div>
                    }
                    {isIos &&
                        <div className={"txt"}>You are using an incompatible browser. Please log in using the safari browser.</div>
                    }
                    <div className={"cta-container"}>
                        {!isIos &&
                            <input className="cf-btn-gradient" type="button" value="Get Chrome" onClick={handleDownloadChrome} />
                        }
                        <span className="browser-container-dismiss" onClick={() => toggleModal(false)}>Dismiss</span>
                    </div>
                </div>
            </div>
        </ModalComponent>
    )
}

export default IncompatibleBrowserModal